import React, { useCallback } from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  useTheme,
} from '@mui/material';
import { useIntl } from 'react-intl';

import {
  IAdditionalDetailKey,
  IItem,
  IAdditionalDetail,
} from 'api/catalog/models';
import NoInformationAvailable from 'ui/ErrorDisplay/NoInformationAvailable';

import messages from '../messages';

const DATA_POINTS: IAdditionalDetailKey[] = ['field', 'source', 'value'];

interface IProps {
  item: IItem;
}

interface IRowProps {
  detail: IAdditionalDetail;
}

const Row = ({ detail }: IRowProps) => {
  const renderCell = useCallback(
    (key: IAdditionalDetailKey): React.ReactNode => {
      switch (key) {
        default:
          return detail[key];
      }
    },
    [detail]
  );

  return (
    <TableRow hover>
      {DATA_POINTS.map((key) => (
        <TableCell key={key}>{renderCell(key)}</TableCell>
      ))}
    </TableRow>
  );
};

const ItemAdditionalDetails = ({ item }: IProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();

  const getLabel = useCallback(
    (key: IAdditionalDetailKey) => {
      switch (key) {
        case 'field':
          return formatMessage(messages.fieldLabel);
        case 'source':
          return formatMessage(messages.sourceLabel);
        case 'value':
          return formatMessage(messages.valueLabel);
        default:
          return key;
      }
    },
    [formatMessage]
  );

  return item.additionalDetails && item.additionalDetails.length > 0 ? (
    <TableContainer>
      <Table size='small'>
        <TableHead>
          <TableRow>
            {DATA_POINTS.map((key) => (
              <TableCell
                key={key}
                sx={{
                  backgroundColor: theme.palette.grey[200],
                  fontWeight: 'bold',
                  border: `1px solid ${theme.palette.divider}`,
                }}
              >
                {getLabel(key)}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {item.additionalDetails.map((detail, index) => (
            <Row key={index} detail={detail} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <NoInformationAvailable minHeight='300px' />
  );
};

export default ItemAdditionalDetails;
